import React, { useCallback, useContext, useRef } from 'react'
import OfferCapacityWithAgesSelectBox from './OfferCapacityWithAgesSelectBox'
import OfferCapacityWithAgesSelection from './OfferCapacityWithAgesSelection'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import OfferFilterFullSizeDropdown from '../OfferFilterFullSizeDropdown'
import styled from 'styled-components'
import { rem } from 'polished'
import OfferPageStateTrackingContext from 'contexts/OfferPage/offerPageStateTrackingContext'
import { useTranslation } from 'react-i18next'

const OfferCapacityDropdown = styled(OfferFilterFullSizeDropdown)`
  padding: 0 ${rem(24)} ${rem(24)};
`

const ScrollingCapacityWithAges = styled(OfferCapacityWithAgesSelection)`
  border-bottom-left-radius: ${props => props.theme.borderRadius.large};
  border-bottom-right-radius: ${props => props.theme.borderRadius.large};
`

interface Props {
  open: boolean;
  offsetDropdown?: boolean;
  capacities?: Array<App.PackageRoomCapacity>;
  disclaimer?: string;
  occupantUnit?: 'guest' | 'traveller';
  childrenAgeLabel?: string
  onApply?: () => void
  enableMultiRoomTypesEvents?: boolean
}

function OfferCapacityWithAgesSelect(props: Props) {
  const { t } = useTranslation('common')

  const {
    open,
    offsetDropdown,
    capacities,
    disclaimer,
    occupantUnit = 'guest',
    childrenAgeLabel = t('at time of check-in', { ns: 'common' }),
    onApply,
    enableMultiRoomTypesEvents,
  } = props
  const trigger = useRef(null)
  const dispatch = useOfferPageDispatch()
  const { trackEvent } = useContext(OfferPageStateTrackingContext)

  const onApplyClose = useCallback(() => {
    dispatch({ type: OfferPageActions.closeFilter })
    trackEvent('OCCUPANCY_FILTERS_CLOSED')
  }, [dispatch, trackEvent])

  return (
    <div>
      <OfferCapacityWithAgesSelectBox
        ref={trigger}
        occupantUnit={occupantUnit}
      />
      <OfferCapacityDropdown
        open={open}
        onClose={onApplyClose}
        offset={offsetDropdown}
        data-testid="OfferCapacitySelect"
      >
        <ScrollingCapacityWithAges
          disclaimer={disclaimer}
          capacities={capacities}
          childrenAgeLabel={childrenAgeLabel}
          onApply={onApply}
          enableMultiRoomTypesEvents={enableMultiRoomTypesEvents}
        />
      </OfferCapacityDropdown>
    </div>
  )
}

export default withOfferPageState(
  (state) => ({
    open: state.activeFilter === 'capacity',
  }))(OfferCapacityWithAgesSelect)
